// extracted by mini-css-extract-plugin
export default {"formVideoBox":"index_formVideoBox_BcNat","formVideoButton":"index_formVideoButton_NFw6I","formVideoUploadInput":"index_formVideoUploadInput_GPrRq"};